function smoothScrollTo(element, duration, offset = 0, callback) {
    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        } else {
            if (typeof callback === 'function') callback();
        }
    }

    // easeInOutQuad
    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}

window.addEventListener('load', () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            const header = document.querySelector('.page-header');

            if (targetElement) {
                const headerOffset = header ? header.offsetHeight : 0;

                // Плавний скрол з врахуванням висоти хедера
                smoothScrollTo(targetElement, 800, headerOffset, () => {
                    // Після завершення скролу – сховати хедер
                    if (header) {
                        // header.style.transition = 'transform 0.3s ease';
                        // header.style.transform = `translateY(-${headerOffset}px)`;
                    }
                });
            }
        });
    });
});
